import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propStr, propArrayShape, propFunc, propOneOf, } from '../../../../../helpers/custom-prop-types';
/**
 * 共有状況のタブ切り替えボタン
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SlideSearchShareStatusTabHeader = (props) => {
    const { className, currentTab, onClick, tabs } = props;
    return (_jsx("ul", Object.assign({ className: clsx('slide_search_share_status_tab_header', className) }, { children: tabs.map((v) => (_jsx("li", Object.assign({ className: clsx('tab_item', v.value === currentTab && 'active') }, { children: _jsxs("button", Object.assign({ className: 'item_button', onClick: onClick, type: 'button', value: v.value }, { children: [_jsx("span", Object.assign({ className: 'button_text' }, { children: v.text })), v.count > 0 && (_jsx("span", Object.assign({ className: 'button_number' }, { children: _jsx("span", { children: v.count }) }))), _jsx("div", { className: 'item_marker' })] })) }), v.value))) })));
};
SlideSearchShareStatusTabHeader.propTypes = {
    className: propStr(),
    currentTab: propOneOf(['receive', 'share']).isRequired,
    onClick: propFunc().isRequired,
    tabs: propArrayShape().isRequired,
};
SlideSearchShareStatusTabHeader.defaultProps = {
    className: '',
};
export default SlideSearchShareStatusTabHeader;
